var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivateFnOLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14511_268)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.2088 3.2088H7.5V0H0V7.5C0 11.6421 3.35794 15 7.5 15C11.6421 15 15 11.6421 15 7.5C15 3.72546 12.2115 0.602693 8.5824 0.0781113V3.34655C10.4289 3.82589 11.7912 5.50306 11.7912 7.5C11.7912 9.87093 9.87093 11.7911 7.5 11.7912C5.12907 11.7912 3.2088 9.87093 3.2088 7.5H7.5V4.2912H3.2088V3.2088Z",
    fill: "#CCCCCC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14511_268"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivateFnOLight);
export default __webpack_public_path__ + "static/media/ActivateFnOLight.63a8cb4bb15a810a025de2c5687058bf.svg";
export { ForwardRef as ReactComponent };